const questionsData = {
  "questions": [
    {
      "id": 1,
      "type": "ai-writing",
      "category": "poetry",
      "question": "Which of these excerpts is really real Shakespeare?",
      "options": [
        "When hope, like ventures cast upon the main, / Did bear my heart toward Fortune's golden shore, / I dream'd rich gain would banish all my pain, / And crown my striving with her treasured store.",
        "In my school days, when I had lost one shaft, / I shot his fellow of the selfsame flight / The selfsame way with more advisèd watch / To find the other forth— and by adventuring both, / I oft found both.",
        "Both are from Shakespeare"
      ],
      "correctAnswer": 1,
      "explanation": "The second excerpt is authentic Shakespeare from 'The Merchant of Venice' (Bassanio's speech). The first is AI-generated attempting to mimic Shakespearean style. Notice the authentic passage has Shakespeare's natural, conversational rhythm and concrete imagery (shooting arrows), while the AI version relies on generic poetic phrases like 'Fortune's golden shore' and overly formal diction."
    },
    {
      "id": 2,
      "type": "ai-writing",
      "category": "poetry",
      "question": "Which poem is really William Wordsworth?",
      "options": [
        "When first I took my short and gentle stride / Along the Dover cliffs at break of day, / The waking sea, in silver-mantled pride, / Did whisper ancient secrets to the bay.",
        "I wandered lonely as a cloud / That floats on high o'er vales and hills, / When all at once I saw a crowd, / A host, of golden daffodils",
        "Both are by Wordsworth"
      ],
      "correctAnswer": 1,
      "explanation": "The second excerpt is Wordsworth's famous 'Daffodils.' The first is AI-generated. Wordsworth uses simple, direct language ('lonely as a cloud') and specific natural imagery. The AI version overdoes the poetic devices with phrases like 'silver-mantled pride' and 'whisper ancient secrets' - telltale signs of AI trying too hard to sound poetic."
    },
    {
      "id": 3,
      "type": "ai-writing",
      "category": "speeches",
      "question": "Which excerpt is from Ronald Reagan's actual 1987 Berlin Wall speech?",
      "options": [
        "Behind me stands a wall that encircles the free sectors of this city, part of a vast system of barriers that divides the entire continent of Europe... General Secretary Gorbachev, if you seek peace, if you seek prosperity for the Soviet Union and Eastern Europe, if you seek liberalization, come here to this gate. Mr. Gorbachev, open this gate! Mr. Gorbachev, tear down this wall!",
        "We gather at a place where history has been paused by concrete and fear. Yet no wall can stop the forward march of human freedom... To the leaders of the East, I say: the future does not belong to those who build walls, but to those who trust their people.",
        "Both are from the same speech"
      ],
      "correctAnswer": 0,
      "explanation": "The first is Reagan's authentic speech with its famous direct address and repetition of 'Mr. Gorbachev.' The AI version uses generic phrases like 'history has been paused' and lacks the specific, bold directness of Reagan's actual words. Real political speeches often have more concrete demands and memorable repetition."
    },
    {
      "id": 4,
      "type": "ai-writing",
      "category": "movie-dialogue",
      "question": "Which line is from the actual movie 'The Social Network'?",
      "options": [
        "You are probably going to be a very successful computer person. But you're going to go through life thinking that girls don't like you because you're a nerd. And I want you to know, from the bottom of my heart, that that won't be true. It'll be because you're an asshole.",
        "Look, Evan, I'm breaking up with you. And no, it's not because you're a nerd. you keep saying that. It's because you're an asshole. I practiced saying this, but it still feels weird.",
        "Both are from the movie"
      ],
      "correctAnswer": 0,
      "explanation": "The first is the iconic opening scene from 'The Social Network.' Aaron Sorkin's dialogue has a specific rhythm and brutal wit. The AI version is more generic and explanatory ('I practiced saying this') - real movie dialogue is tighter and more naturalistic. Notice how the authentic line builds to the punchline, while the fake one telegraphs it."
    },
    {
      "id": 5,
      "type": "image-detection",
      "category": "ai-generated",
      "question": "Look at the two images. Which one is real?",
      "images": [
        "/images/q5-fake-img.png",
        "/images/q5-real-img.jpg"
      ],
      "options": [
        "The first image",
        "The second image",
        "Both are real"
      ],
      "correctAnswer": 1,
      "explanation": "The second image is the real photograph. AI-generated images often have telltale signs like overly perfect details, inconsistent lighting, or subtle artifacts. Real photographs show natural variations, authentic textures, and realistic imperfections that AI struggles to replicate perfectly."
    },
    {
      "id": 6,
      "type": "ai-writing",
      "category": "college-essays",
      "question": "Which college essay excerpt was written by a human?",
      "options": [
        "Managing to break free from my mother's grasp, I charged. With arms flailing and chubby legs fluttering beneath me, I was the ferocious two year old rampaging through Costco on a Saturday morning. My mother's eyes widened in horror as I jettisoned my churro...",
        "Some people say they love adventure, but for me, discovery has always been something deeper—an impulse, almost a gravitational pull. I can trace it back to the Rose Bowl flea market in Los Angeles, where my mom used to take me when I was little.",
        "Both are human-written"
      ],
      "correctAnswer": 0,
      "explanation": "The first is the famous Costco essay - genuine human writing with vivid, specific details ('jettisoned my churro,' 'chubby legs fluttering'). The AI version uses generic metaphors ('gravitational pull,' 'discovery has always been something deeper') and lacks the concrete sensory details. Human writers show, AI writers tell."
    },
    {
      "id": 7,
      "type": "image-detection",
      "category": "ai-generated",
      "question": "Look at the two images. Which one is real?",
      "images": [
        "/images/q7-fake-img.png",
        "/images/q7-real-img.jpg"
      ],
      "options": [
        "The first image",
        "The second image",
        "Both are real"
      ],
      "correctAnswer": 1,
      "explanation": "The second image is the real photograph. AI-generated images often have telltale signs like overly perfect details, inconsistent lighting, or subtle artifacts. Real photographs show natural variations, authentic textures, and realistic imperfections that AI struggles to replicate perfectly."
    },
    {
      "id": 8,
      "type": "ai-writing",
      "category": "poetry",
      "question": "Which excerpt is from Walt Whitman's actual poem 'O Captain! My Captain!'?",
      "options": [
        "O Captain! my Captain! our fearful trip is done, / The ship has weather'd every rack, the prize we sought is won, / The port is near, the bells I hear, the people all exulting",
        "O Leader! my Leader! our fearful march is done, / The road has braved each thundered threat, the hard-won prize is won, / The gate is nigh, the horns I hear, the gathered crowd is cheering",
        "Both are by Whitman"
      ],
      "correctAnswer": 0,
      "explanation": "The first is Whitman's famous elegy for Lincoln. The AI version mechanically swaps words (Captain→Leader, trip→march, ship→road) but loses Whitman's specific maritime metaphor and emotional resonance. AI often creates variations by simple word substitution rather than genuine creative expression."
    },
    {
      "id": 9,
      "type": "image-detection",
      "category": "sculpture",
      "question": "Look at the two images of the 'Winged Victory of Samothrace' sculpture. Which one is the real sculpture?",
      "images": [
        "/images/q9-real-img.jpg",
        "/images/q9-fake-img.png"
      ],
      "options": [
        "The first image",
        "The second image",
        "Both are real"
      ],
      "correctAnswer": 0,
      "explanation": "Yes - the real sculpture is in fact incomplete.The first is the authentic ancient Greek sculpture housed in the Louvre. AI-generated classical sculptures often have overly smooth surfaces, impossible drapery physics, or proportions that look 'too perfect.' Real ancient sculptures show weathering, realistic fabric flow, and historically accurate proportions."
    },
    {
      "id": 10,
      "type": "ai-writing",
      "category": "poetry",
      "question": "Which excerpt is from Edgar Allan Poe's actual poem 'Annabel Lee'?",
      "options": [
        "It was many and many a year ago, / In a kingdom by the sea, / That a maiden there lived whom you may know / By the name of Annabel Lee",
        "It was many and many a mile I roamed, / Through a kingdom wild and free, / For I followed a path that forever was shown / By the love of my Annabel Lee",
        "Both are by Poe"
      ],
      "correctAnswer": 0,
      "explanation": "The first is Poe's iconic opening with its famous rhythm and specific setting ('kingdom by the sea'). The AI version copies the structure but changes key elements that made Poe's version memorable. Notice how AI maintains the meter but loses the haunting simplicity of the original."
    },
    {
      "id": 11,
      "type": "ai-writing",
      "category": "poetry",
      "question": "Which excerpt is from Emma Lazarus's actual poem 'The New Colossus' (on the Statue of Liberty)?",
      "options": [
        "Not on the salt-born tides where wanderers roam, / But at the dust-stirred threshold of the plains; / Here by our wind-carved, sunlit pass shall rise / A steadfast matron with a staff",
        "Not like the brazen giant of Greek fame, / With conquering limbs astride from land to land; / Here at our sea-washed, sunset gates shall stand / A mighty woman with a torch, whose flame / Is the imprisoned lightning",
        "Both are from 'The New Colossus'"
      ],
      "correctAnswer": 1,
      "explanation": "The second is Lazarus's actual poem with its powerful imagery ('imprisoned lightning'). The AI version awkwardly changes the maritime setting to a land-based one, losing the poem's essential meaning. It replaces 'torch' with 'staff' and 'sea-washed' with 'dust-stirred' - losing the connection to Ellis Island and immigration."
    },
    // {
    //   "id": 16,
    //   "type": "image-detection",
    //   "category": "ai-generated",
    //   "question": "Is this image fake or real?",
    //   "images": [
    //     "/images/q16-fake-img.jpg"
    //   ],
    //   "options": [
    //     "Real",
    //     "Fake",
    //     "Cannot determine"
    //   ],
    //   "correctAnswer": 1,
    //   "explanation": "This image is AI-generated (fake). Look for telltale signs of AI generation: overly perfect details, inconsistent lighting, subtle artifacts, or elements that don't quite make sense upon closer inspection. Real photographs show natural variations, authentic textures, and realistic imperfections."
    // },
    {
      "id": 22,
      "type": "ai-writing",
      "category": "political-speeches",
      "question": "Which quote is something George W. Bush actually said?",
      "options": [
        "Border relations between Canada and Mexico have never been better.",
        "Leadership isn't about knowing the answers; it's about confidently explaining why you don't have them yet.",
        "Both are real Bush quotes"
      ],
      "correctAnswer": 0,
      "explanation": "The first is a genuine Bush malapropism from 2004 - mixing up Canada and Mexico shows his authentic speaking style. The AI version is too polished and self-aware to be a real Bushism. Real Bush quotes have an unintentional quality; the fake one sounds like someone deliberately trying to sound confused."
    },
    // {
    //   "id": 23,
    //   "type": "ai-writing",
    //   "category": "political-speeches",
    //   "question": "Which is an actual George W. Bush quote?",
    //   "options": [
    //     "I think if you know what you believe, it makes it a lot easier to answer questions. I can't answer your question.",
    //     "When we say we'll stay the course, we mean we're committed to figuring out where the course is.",
    //     "Both are real Bush quotes"
    //   ],
    //   "correctAnswer": 0,
    //   "explanation": "The first is a real 2000 Bush quote with genuine unintentional irony. The AI version is too deliberately comedic - real Bushisms are accidentally contradictory, not meta-commentary on leadership. The authentic quote captures Bush's actual speaking patterns and unplanned contradictions."
    // },
    {
      "id": 25,
      "type": "ai-capabilities",
      "category": "limitations",
      "question": "Which statement about AI capabilities is FALSE?",
      "options": [
        "ChatGPT can write functional code in multiple programming languages",
        "ChatGPT can reliably detect whether content was written by AI",
        "ChatGPT can explain complex concepts in simpler terms"
      ],
      "correctAnswer": 1,
      "explanation": "AI cannot reliably detect AI-generated content - this is a common misconception. Even specialized AI detection tools have high error rates (30-40% false positives). The irony is that AI companies themselves acknowledge their models can't consistently identify AI-generated text, yet people often trust these tools."
    },
    {
      "id": 26,
      "type": "ai-writing",
      "category": "speeches",
      "question": "Which excerpt is from Martin Luther King Jr.'s actual 'I Have a Dream' speech?",
      "options": [
        "In this moment, we gather with a shared conviction that every person deserves the full light of dignity. We stand because hope asks us to rise, and because the promise of tomorrow belongs to all of us.",
        "We cannot walk alone. And as we walk we must make the pledge that we shall always march ahead. We cannot turn back. There are those who are asking the devotees of civil rights, 'When will you be satisfied?' We can never be satisfied as long as the Negro is the victim of the unspeakable horrors of police brutality.",
        "Both are from the speech"
      ],
      "correctAnswer": 1,
      "explanation": "The second is MLK's authentic speech with its powerful repetition ('we cannot') and specific, concrete grievances. The AI version uses vague inspirational language ('full light of dignity,' 'hope asks us to rise') without the specificity and rhetorical power of King's actual words. Real civil rights speeches name injustices directly."
    },
    {
      "id": 27,
      "type": "ai-writing",
      "category": "speeches",
      "question": "Which excerpt is from Winston Churchill's actual 'We Shall Fight on the Beaches' speech?",
      "options": [
        "We shall go on to the end, we shall fight in France, we shall fight on the seas and oceans, we shall fight with growing confidence and growing strength in the air, we shall defend our Island, whatever the cost may be, we shall fight on the beaches, we shall fight on the landing grounds, we shall fight in the fields and in the streets, we shall fight in the hills; we shall never surrender",
        "And should the darkness deepen, should the tempest roar with yet greater fury, we shall still hold fast to the ancient virtues that have steeled our people through many a grievous age. We shall bind up our wounds, we shall marshal our strength, and we shall stand, calm and unbroken",
        "Both are from Churchill"
      ],
      "correctAnswer": 0,
      "explanation": "The first is Churchill's famous speech with its iconic repetition of 'we shall fight.' The AI version uses period-appropriate vocabulary but lacks Churchill's specific, concrete locations and the driving rhythm of his anaphora. Real Churchill is direct and specific; the fake version is more abstract and flowery."
    },
    {
      "id": 28,
      "type": "ai-writing",
      "category": "speeches",
      "question": "Which excerpt is from Barack Obama's actual 2008 victory speech?",
      "options": [
        "A man touched down on the moon, a wall came down in Berlin, a world was connected by our own science and imagination. And this year, in this election, she touched her finger to a screen and cast her vote, because after 106 years in America, through the best of times and the darkest of hours, she knows how America can change. Yes, we can.",
        "And years from now, when a young girl looks back on this night — when she reads of bridges built between neighbors, of storms weathered by hands joined in common cause, of horizons widened by courage rather than fear — she will know that we were not passive observers of history, but its authors.",
        "Both are from the speech"
      ],
      "correctAnswer": 0,
      "explanation": "The first is Obama's actual speech referencing Ann Nixon Cooper, a 106-year-old voter. It uses specific historical touchstones (moon landing, Berlin Wall) and concrete details. The AI version uses generic inspirational metaphors ('bridges built,' 'storms weathered') without the grounding in specific people and events that made Obama's speech powerful."
    },
    // {
    //   "id": 30,
    //   "type": "image-detection",
    //   "category": "ai-generated",
    //   "question": "Which statement about AI image generation is TRUE?",
    //   "options": [
    //     "AI-generated images always have visible watermarks",
    //     "AI image generators often struggle with hands, text, and reflections",
    //     "AI cannot create photorealistic images"
    //   ],
    //   "correctAnswer": 1,
    //   "explanation": "AI consistently struggles with hands (wrong finger counts, impossible positions), text (gibberish or warped letters), and reflections (physics don't match). These are the most reliable tells for detecting AI images. AI can create very photorealistic images, and watermarks are optional, so those statements are false."
    // },


    // Add these to your questionsData.questions array

{
  "id": 31,
  "type": "ai-writing",
  "category": "poetry",
  "question": "Which excerpt is from Robert Frost's actual poem 'The Road Not Taken'?",
  "options": [
    "Two roads diverged in a yellow wood, / And sorry I could not travel both / And be one traveler, long I stood / And looked down one as far as I could / To where it bent in the undergrowth",
    "Two paths diverged in an autumn wood, / And sad that I could walk but one / As one lone traveler there I stood / And gazed along each path as long / As sight would carry to the trees beyond",
    "Both are by Frost"
  ],
  "correctAnswer": 0,
  "explanation": "The first is Frost's actual poem with its famous opening and specific imagery ('yellow wood,' 'bent in the undergrowth'). The AI version tries to mimic the structure but uses synonyms (paths/roads, sad/sorry, autumn/yellow) that lose Frost's precise word choice and natural rhythm."
},
{
  "id": 32,
  "type": "ai-writing",
  "category": "speeches",
  "question": "Which excerpt is from John F. Kennedy's actual inaugural address?",
  "options": [
    "And so, my fellow Americans: ask not what your country can do for you—ask what you can do for your country. My fellow citizens of the world: ask not what America will do for you, but what together we can do for the freedom of man.",
    "And so, my fellow citizens: consider not what your nation owes to you—consider what you owe to your nation. My fellow people of the world: think not what America can give to you, but what together we might build for the liberty of all.",
    "Both are from Kennedy"
  ],
  "correctAnswer": 0,
  "explanation": "The first is Kennedy's iconic call to action with its famous parallel structure and the word 'ask not.' The AI version awkwardly substitutes words (consider/ask, nation/country, owe/do) that destroy the rhythm and memorability. Real Kennedy has punchy, memorable phrasing; the fake is wordier and less direct."
},
{
  "id": 35,
  "type": "ai-writing",
  "category": "poetry",
  "question": "Which excerpt is from Emily Dickinson's actual poetry?",
  "options": [
    "Because I could not stop for Death – / He kindly stopped for me – / The Carriage held but just Ourselves – / And Immortality.",
    "Because I could not pause for Time – / It gently paused for me – / The Moment held but just Ourselves – / And sweet Eternity.",
    "Both are by Dickinson"
  ],
  "correctAnswer": 0,
  "explanation": "The first is Dickinson's famous poem with her characteristic personification of Death and specific imagery (the Carriage). The AI version mechanically substitutes words (Death→Time, stop→pause, Carriage→Moment) but loses the poem's power. Dickinson's concrete 'Carriage' becomes the vague 'Moment,' and 'kindly stopped' is stronger than 'gently paused.'"
},
{
  "id": 36,
  "type": "ai-writing",
  "category": "movie-dialogue",
  "question": "Which line is from the actual movie 'The Godfather'?",
  "options": [
    "I'm going to make him an offer he can't refuse.",
    "I'll present him a proposal he'll find impossible to decline.",
    "Both are from the movie"
  ],
  "correctAnswer": 0,
  "explanation": "The first is the iconic line from 'The Godfather.' The AI version is technically saying the same thing but loses all the power through wordiness and formality. Real memorable movie dialogue is concise and natural; AI tends to be verbose and stilted. Great screenwriting is about economy of language."
},
{
  "id": 38,
  "type": "ai-writing",
  "category": "business",
  "question": "Which email opening was written by a human?",
  "options": [
    "Hope this email finds you well! I wanted to reach out regarding the exciting opportunity we discussed last week.",
    "Hey Sarah — Quick question: did the client ever get back to you about the logo revisions? I've got the printer on standby but they need files by EOD.",
    "Both are human-written"
  ],
  "correctAnswer": 1,
  "explanation": "The second has natural, specific details (names, deadlines, context) and realistic workplace urgency. The AI version uses generic pleasantries ('Hope this finds you well,' 'exciting opportunity') without substance. Real workplace emails get to the point quickly with specific details; AI emails are filled with corporate buzzwords and empty phrases."
},
{
  "id": 39,
  "type": "ai-writing",
  "category": "poetry",
  "question": "Which excerpt is from Langston Hughes's actual poem?",
  "options": [
    "I've known rivers: / I've known rivers ancient as the world and older than the flow of human blood in human veins. / My soul has grown deep like the rivers.",
    "I have walked beside the waters: / I have walked beside waters timeless as the earth and older than the pulse of mortal hearts. / My spirit has grown vast like the waters.",
    "Both are by Hughes"
  ],
  "correctAnswer": 0,
  "explanation": "The first is from Hughes's 'The Negro Speaks of Rivers' with its powerful repetition and specific imagery ('flow of human blood in human veins'). The AI version copies the structure but weakens it with word substitutions (rivers→waters, known→walked beside, soul→spirit). Hughes's concrete 'deep' becomes the vague 'vast.'"
},
// {
//   "id": 40,
//   "type": "ai-capabilities",
//   "category": "limitations",
//   "question": "Which of these can AI NOT reliably do?",
//   "options": [
//     "Translate text between common languages",
//     "Predict exact future events with certainty",
//     "Summarize long documents"
//   ],
//   "correctAnswer": 1,
//   "explanation": "AI cannot predict the future with certainty—it can only analyze patterns and make probabilistic guesses. This is a fundamental limitation. AI is generally good at translation and summarization (though not perfect), but prediction requires information that doesn't exist yet. Many people mistakenly think AI's pattern recognition means it can forecast specific outcomes."
// },
{
  "id": 41,
  "type": "ai-writing",
  "category": "speeches",
  "question": "Which excerpt is from Steve Jobs's actual 2005 Stanford commencement speech?",
  "options": [
    "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma — which is living with the results of other people's thinking. Don't let the noise of others' opinions drown out your own inner voice.",
    "Time is our most precious resource, so invest it wisely in your own path. Don't be constrained by convention — which is simply accepting the inherited wisdom of previous generations. Don't allow the chorus of external voices to overshadow your authentic self.",
    "Both are from the speech"
  ],
  "correctAnswer": 0,
  "explanation": "The first is Jobs's actual speech with his characteristic direct, punchy style. The AI version is wordier and more formal ('invest it wisely,' 'inherited wisdom,' 'authentic self'). Jobs spoke in short, powerful sentences; the AI version sounds like a self-help book. Real Jobs is conversational and bold; fake Jobs is cautious and verbose."
},
{
  "id": 42,
  "type": "ai-writing",
  "category": "poetry",
  "question": "Which excerpt is from Maya Angelou's actual poem 'Still I Rise'?",
  "options": [
    "You may write me down in history / With your bitter, twisted lies, / You may trod me in the very dirt / But still, like dust, I'll rise.",
    "You may record me in your annals / With your cruel and winding tales, / You may press me to the cold earth / But still, like smoke, I'll rise.",
    "Both are by Angelou"
  ],
  "correctAnswer": 0,
  "explanation": "The first is Angelou's powerful poem with its specific, visceral imagery ('trod me in the very dirt,' 'like dust'). The AI version uses more formal language ('annals,' 'cruel and winding tales') and changes the central metaphor to 'smoke,' losing the connection to earth and oppression. Angelou's concrete imagery makes the poem's power."
},
{
  "id": 43,
  "type": "ai-writing",
  "category": "movie-dialogue",
  "question": "Which line is from the actual movie 'Casablanca'?",
  "options": [
    "Here's looking at you, kid.",
    "Here's to you, sweetheart.",
    "Both are from the movie"
  ],
  "correctAnswer": 0,
  "explanation": "The first is one of cinema's most famous lines. The AI version tries to create something similar but loses the specific phrasing that made it iconic. 'Looking at you, kid' has a rhythm and character that 'to you, sweetheart' doesn't capture. Great movie lines are often idiosyncratic; AI versions tend toward the generic."
},
{
  "id": 44,
  "type": "ai-capabilities",
  "category": "limitations",
  "question": "What happens when you ask ChatGPT to count the number of R's in 'strawberry'?",
  "options": [
    "It correctly identifies 3 R's every time",
    "It often makes mistakes because it processes text as tokens, not individual letters",
    "It refuses to answer because it's too simple a question"
  ],
  "correctAnswer": 1,
  "explanation": "AI frequently struggles with character-level tasks like counting letters because it processes text as chunks (tokens), not individual characters. This is a famous example of how AI can fail at tasks that seem trivial to humans. It's a fundamental limitation of how language models process text, not a simple bug."
},
{
  "id": 45,
  "type": "ai-writing",
  "category": "news",
  "question": "Which opening is from a real news article?",
  "options": [
    "The landscape of artificial intelligence is rapidly evolving, presenting both unprecedented opportunities and complex challenges that society must navigate with careful consideration.",
    "Elon Musk's lawyers filed a motion Friday to block OpenAI's conversion to a for-profit company, escalating a monthslong legal battle between the former allies.",
    "Both are from real articles"
  ],
  "correctAnswer": 1,
  "explanation": "The second is real journalism with specific names, dates, and news developments. The AI version is full of vague buzzwords ('rapidly evolving,' 'unprecedented opportunities,' 'complex challenges') without any actual news. Real articles report events; AI-generated ones often provide context without substance."
},



// ... previous questions ...

// {
//   "id": 46,
//   "type": "ai-writing",
//   "category": "coding",
//   "question": "Which code comment was written by a frustrated human developer?",
//   "options": [
//     "// This function iterates through the user array and filters by active status to ensure data integrity before export.",
//     "// honestly i have no idea why this works but if you delete it the whole dashboard crashes so purely purely leave it alone",
//     "Both are human-written"
//   ],
//   "correctAnswer": 1,
//   "explanation": "The second is a classic human developer comment. It expresses frustration, honesty about lack of understanding ('magic code'), and fear of breaking things. AI comments tend to be perfectly descriptive, emotionally sterile, and overly explanatory of what the code is doing."
// },
// {
//   "id": 47,
//   "type": "ai-writing",
//   "category": "lyrics",
//   "question": "Which lyrics are from Taylor Swift's actual song 'All Too Well'?",
//   "options": [
//     "And you call me up again just to break me like a promise / So casually cruel in the name of being honest",
//     "The autumn leaves are falling down like my tears upon the ground / I remember the way you looked at me when no one was around",
//     "Both are by Swift"
//   ],
//   "correctAnswer": 0,
//   "explanation": "The first is the iconic bridge from 'All Too Well.' Swift is known for specific, cutting turns of phrase ('casually cruel'). The AI version relies on the most generic pop-country tropes imaginable (rhyming 'falling down' with 'ground' and 'tears'). AI struggles to create unique, non-cliché metaphors."
// },
{
  "id": 48,
  "type": "ai-writing",
  "category": "recipe-blog",
  "question": "Which backstory is from a real food blog?",
  "options": [
    "The juxtaposition of the savory broth and the delicate noodles creates a symphony of flavors that transports the soul to a place of culinary nirvana, reminding us that food is not just fuel, but art.",
    "My toddler threw the broccoli on the floor three times, so I hid it in this mac and cheese. He ate two bowls. I'm calling this a win before I collapse on the couch.",
    "Both are human-written"
  ],
  "correctAnswer": 1,
  "explanation": "The second is a real human parent blogging. It contains specific, messy life details and exhaustion. The AI version uses over-the-top sensory language ('symphony of flavors', 'culinary nirvana') that sounds like a bad ad copy. AI tries too hard to romanticize food; humans just want to get dinner on the table."
},
{
  "id": 49,
  "type": "ai-writing",
  "category": "movie-dialogue",
  "question": "Which dialogue is from Quentin Tarantino's 'Pulp Fiction'?",
  "options": [
    "You know what they call a Quarter Pounder with Cheese in Paris? They don't call it a Quarter Pounder with Cheese. They got the metric system. They wouldn't know what the f*** a Quarter Pounder is.",
    "Listen to me, we need to get that briefcase back. It's not about the money anymore, it's about the principle. You don't cross a man like Marsellus Wallace and expect to walk away clean.",
    "Both are from the movie"
  ],
  "correctAnswer": 0,
  "explanation": "The first is the famous 'Royale with Cheese' dialogue. Tarantino writes conversations about mundane trivia (burgers, TV shows) that feel incredibly real and random. The AI version writes generic 'tough guy' movie plot exposition ('it's about the principle') that lacks the specific, pop-culture-obsessed voice of Tarantino."
},
// {
//   "id": 50,
//   "type": "ai-capabilities",
//   "category": "logic",
//   "question": "If you ask an older AI model: 'I have 3 shirts. It takes 1 hour to dry them outside. How long does it take to dry 30 shirts?', what might it incorrectly say?",
//   "options": [
//     "10 hours",
//     "1 hour",
//     "It depends on the weather"
//   ],
//   "correctAnswer": 0,
//   "explanation": "Early AI models often fail at 'common sense' logic puzzles, assuming a linear mathematical relationship (3 shirts = 1 hour, so 30 shirts = 10 hours) rather than understanding the context that you can hang all shirts at the same time. This highlights that AI predicts tokens based on math patterns, not physical world understanding."
// },
{
  "id": 51,
  "type": "ai-writing",
  "category": "social-media",
  "question": "Which is a real viral tweet?",
  "options": [
    "just found out my birthday is the same day I was born... life is crazy",
    "The serendipity of existence is truly fascinating when you consider how the alignment of celestial bodies influences our daily interactions.",
    "Both are real tweets"
  ],
  "correctAnswer": 0,
  "explanation": "The first is a classic absurdist/humorous tweet. Internet humor often relies on deliberate stupidity or anti-jokes. The AI version tries to be profound and philosophical ('serendipity of existence'), completely missing the tone of Twitter/X, which favors irony and brevity."
},
{
  "id": 52,
  "type": "ai-writing",
  "category": "lyrics",
  "question": "Which lyrics are from Nirvana's 'Smells Like Teen Spirit'?",
  "options": [
    "The shadows of my youth are fading fast / I'm looking for a future that will last / The anger in my heart is burning bright",
    "A mulatto, an albino, a mosquito, my libido / Yeah, hey",
    "Both are by Nirvana"
  ],
  "correctAnswer": 1,
  "explanation": "The second is Kurt Cobain's actual writing—nonsensical, rhyming for the sound rather than the meaning, and raw. The AI version writes generic 'angsty teen' poetry ('shadows of my youth') that makes logical sense but lacks the chaotic, abstract energy of Grunge."
},
{
  "id": 53,
  "type": "ai-writing",
  "category": "reddit",
  "question": "Which title sounds like a real 'Am I The Asshole' (AITA) Reddit post?",
  "options": [
    "AITA for screaming at my mother-in-law after she fed my vegan cat turkey slices on Thanksgiving?",
    "AITA for expressing my displeasure to a family member regarding a dietary disagreement concerning my pet?",
    "Both are real posts"
  ],
  "correctAnswer": 0,
  "explanation": "The first captures the specific, chaotic, and often ridiculous nature of Reddit drama ('vegan cat', 'turkey slices'). The AI version sanitizes the conflict into corporate-speak ('expressing my displeasure,' 'dietary disagreement'). Real internet drama is messy and specific; AI tries to be polite and vague."
},
{
  "id": 54,
  "type": "ai-writing",
  "category": "comedy",
  "question": "Which is a real Seinfeld stand-up bit?",
  "options": [
    "You know what's the deal with airline food? It's small, it's plastic, and nobody knows where it comes from. Why can't they just give us a normal sandwich?",
    "I'm on the plane, we left late. Pilot says we're going to be making up some time in the air. I thought, well isn't that interesting. We'll just make up time... Now, my question is if you can go faster, why don't you just go as fast as you can all the time?",
    "Both are real bits"
  ],
  "correctAnswer": 1,
  "explanation": "The second is actual Seinfeld. He deconstructs a specific phrase ('make up time') and follows the logic to an absurdity. The AI version relies on the stereotypical 'What's the deal with airline food?' trope that everyone *thinks* Seinfeld does, but creates a generic observation rather than a specific structural joke."
},
{
  "id": 55,
  "type": "ai-writing",
  "category": "email",
  "question": "Which is a real 'out of office' auto-reply?",
  "options": [
    "I will be away from my desk with limited access to email. I will respond to your inquiry promptly upon my return.",
    "I'm currently at a music festival in the desert with zero signal. If this is an emergency, call 911. If it's about the project, panic quietly until Monday.",
    "Both are human-written"
  ],
  "correctAnswer": 1,
  "explanation": "While the first is a standard corporate reply (which AI can mimic perfectly), the second shows human personality, humor, and specific context ('music festival'). AI struggles to write informal, humorous, or slightly unprofessional messages unless explicitly prompted to be 'funny,' and even then, it rarely nails the tone."
}




  ]
};

export default questionsData;